import type { AssetDefinition } from '../types';

export const ASSETS: AssetDefinition[] = [
  {
    kind: 'x-banner',
    name: 'X 배너 60',
    category: '디스플레이',
    description: '출력면 600 × 1,800 mm',
    dimensions: { width: 0.6, height: 1.8, depth: 0.45 },
    defaultColor: '#f3f1e8',
  },
  {
    kind: 'table',
    name: '전시 테이블',
    category: '가구',
    description: '1,800 × 750 × 800 mm',
    dimensions: { width: 1.8, height: 0.75, depth: 0.8 },
    defaultColor: '#c9c5ba',
  },
  {
    kind: 'tv',
    name: '55인치 TV',
    category: '디스플레이',
    description: '스탠드/벽걸이 1,230 × 1,650 mm',
    dimensions: { width: 1.23, height: 1.65, depth: 0.55 },
    defaultColor: '#272b2a',
  },
  {
    kind: 'scroll-banner',
    name: '벽걸이 족자',
    category: '디스플레이',
    description: '600 × 1,800 mm 벽면 부착',
    dimensions: { width: 0.6, height: 1.8, depth: 0.04 },
    defaultColor: '#f3f1e8',
  },
  {
    kind: 'chair',
    name: '라운지 체어',
    category: '가구',
    description: '640 × 780 × 670 mm',
    dimensions: { width: 0.64, height: 0.78, depth: 0.67 },
    defaultColor: '#4f6259',
  },
  {
    kind: 'podium',
    name: '사각 진열대',
    category: '가구',
    description: '500 × 900 × 500 mm',
    dimensions: { width: 0.5, height: 0.9, depth: 0.5 },
    defaultColor: '#dedbd2',
  },
  {
    kind: 'plant',
    name: '대형 화분',
    category: '장식',
    description: '폭 700 × 높이 1,450 mm',
    dimensions: { width: 0.7, height: 1.45, depth: 0.7 },
    defaultColor: '#53634e',
  },
  {
    kind: 'round-table',
    name: '원형 상담 테이블',
    category: '가구',
    description: '지름 900 × 높이 740 mm',
    dimensions: { width: 0.9, height: 0.74, depth: 0.9 },
    defaultColor: '#d4d0c5',
  },
  {
    kind: 'stool',
    name: '바 스툴',
    category: '가구',
    description: '450 × 760 × 450 mm',
    dimensions: { width: 0.45, height: 0.76, depth: 0.45 },
    defaultColor: '#63736b',
  },
  {
    kind: 'brochure-rack',
    name: '팜플렛 거치대',
    category: '장식',
    description: '350 × 1,350 × 420 mm',
    dimensions: { width: 0.35, height: 1.35, depth: 0.42 },
    defaultColor: '#aeb5b0',
  },
  {
    kind: 'brochure',
    name: 'A4 팜플렛',
    category: '장식',
    description: '210 × 297 × 8 mm',
    dimensions: { width: 0.21, height: 0.297, depth: 0.008 },
    defaultColor: '#f1eee4',
  },
  {
    kind: 'brochure-trifold',
    name: '3단 리플렛',
    category: '장식',
    description: '100 × 210 × 12 mm',
    dimensions: { width: 0.1, height: 0.21, depth: 0.012 },
    defaultColor: '#e6c46a',
  },
  {
    kind: 'counter',
    name: '안내 카운터',
    category: '부스 구조',
    description: '1,200 × 1,050 × 550 mm',
    dimensions: { width: 1.2, height: 1.05, depth: 0.55 },
    defaultColor: '#dedbd2',
  },
  {
    kind: 'partition',
    name: '독립 파티션',
    category: '부스 구조',
    description: '1,000 × 2,200 × 180 mm',
    dimensions: { width: 1, height: 2.2, depth: 0.18 },
    defaultColor: '#e2e2dc',
  },
  {
    kind: 'arch-sign',
    name: '입구 아치 사인',
    category: '부스 구조',
    description: '2,400 × 2,500 × 400 mm',
    dimensions: { width: 2.4, height: 2.5, depth: 0.4 },
    defaultColor: '#394842',
  },
  {
    kind: 'system-booth',
    name: '옥타늄 기본 부스',
    category: '부스 구조',
    description: '3,000 × 2,500 × 2,000 mm',
    dimensions: { width: 3, height: 2.5, depth: 2 },
    defaultColor: '#e7e6df',
  },
  {
    kind: 'corner-booth',
    name: '코너형 시스템 부스',
    category: '부스 구조',
    description: '3,000 × 2,500 × 3,000 mm',
    dimensions: { width: 3, height: 2.5, depth: 3 },
    defaultColor: '#e7e6df',
  },
  {
    kind: 'truss-booth',
    name: '트러스 게이트 부스',
    category: '부스 구조',
    description: '3,000 × 2,700 × 500 mm',
    dimensions: { width: 3, height: 2.7, depth: 0.5 },
    defaultColor: '#59635f',
  },
  {
    kind: 'spotlight',
    name: '플로어 스포트라이트',
    category: '장식',
    description: '350 × 1,650 × 350 mm',
    dimensions: { width: 0.35, height: 1.65, depth: 0.35 },
    defaultColor: '#303534',
  },
  {
    kind: 'trash-bin',
    name: '원형 휴지통',
    category: '장식',
    description: '지름 320 × 높이 680 mm',
    dimensions: { width: 0.32, height: 0.68, depth: 0.32 },
    defaultColor: '#69716d',
  },
  {
    kind: 'cube-stand-s',
    name: '큐브 전시대 소형',
    category: '가구',
    description: '500 × 600 × 500 mm',
    dimensions: { width: 0.5, height: 0.6, depth: 0.5 },
    defaultColor: '#f2f0e8',
  },
  {
    kind: 'cube-stand-m',
    name: '큐브 전시대 중형',
    category: '가구',
    description: '500 × 800 × 500 mm',
    dimensions: { width: 0.5, height: 0.8, depth: 0.5 },
    defaultColor: '#f2f0e8',
  },
  {
    kind: 'cube-stand-l',
    name: '큐브 전시대 대형',
    category: '가구',
    description: '500 × 1,000 × 500 mm',
    dimensions: { width: 0.5, height: 1, depth: 0.5 },
    defaultColor: '#f2f0e8',
  },
  {
    kind: 'a-board',
    name: 'A보드 입간판',
    category: '디스플레이',
    description: '600 × 1,100 × 550 mm',
    dimensions: { width: 0.6, height: 1.1, depth: 0.55 },
    defaultColor: '#222826',
  },
  {
    kind: 't-board',
    name: 'T보드 입간판',
    category: '디스플레이',
    description: '700 × 1,500 × 450 mm',
    dimensions: { width: 0.7, height: 1.5, depth: 0.45 },
    defaultColor: '#1f2422',
  },
  {
    kind: 'easel-wood',
    name: '나무 이젤',
    category: '디스플레이',
    description: '550 × 1,600 × 550 mm',
    dimensions: { width: 0.55, height: 1.6, depth: 0.55 },
    defaultColor: '#b08958',
  },
  {
    kind: 'easel-metal',
    name: '철제 이젤',
    category: '디스플레이',
    description: '500 × 1,650 × 500 mm',
    dimensions: { width: 0.5, height: 1.65, depth: 0.5 },
    defaultColor: '#3a403d',
  },
  {
    kind: 'dura-table',
    name: '듀라테이블 1800',
    category: '가구',
    description: '1,800 × 740 × 750 mm',
    dimensions: { width: 1.8, height: 0.74, depth: 0.75 },
    defaultColor: '#ebe6da',
  },
  {
    kind: 'bar-table',
    name: '원형 바테이블',
    category: '가구',
    description: '지름 600 × 높이 1,100 mm',
    dimensions: { width: 0.6, height: 1.1, depth: 0.6 },
    defaultColor: '#f3f1ea',
  },
  {
    kind: 'magazine-rack-4',
    name: '4단 접이식 잡지꽂이',
    category: '장식',
    description: '280 × 1,200 × 350 mm',
    dimensions: { width: 0.28, height: 1.2, depth: 0.35 },
    defaultColor: '#2f3532',
  },
  {
    kind: 'magazine-rack-6',
    name: '6단 접이식 잡지꽂이',
    category: '장식',
    description: '300 × 1,450 × 380 mm',
    dimensions: { width: 0.3, height: 1.45, depth: 0.38 },
    defaultColor: '#aeb5b0',
  },
  {
    kind: 'stanchion',
    name: '벨트 차단봉',
    category: '장식',
    description: '지름 360 × 높이 1,000 mm',
    dimensions: { width: 0.36, height: 1, depth: 0.36 },
    defaultColor: '#1c1f1e',
  },
  {
    kind: 'lectern-wood',
    name: '우드 강연대',
    category: '가구',
    description: '550 × 1,150 × 450 mm',
    dimensions: { width: 0.55, height: 1.15, depth: 0.45 },
    defaultColor: '#d8d2c4',
  },
  {
    kind: 'lectern-acrylic',
    name: '아크릴 강연대',
    category: '가구',
    description: '600 × 1,200 × 450 mm',
    dimensions: { width: 0.6, height: 1.2, depth: 0.45 },
    defaultColor: '#dfe8e6',
  },
  {
    kind: 'showcase',
    name: '1단 유리 쇼케이스',
    category: '가구',
    description: '1,000 × 1,000 × 450 mm',
    dimensions: { width: 1, height: 1, depth: 0.45 },
    defaultColor: '#eceae3',
  },
  {
    kind: 'standbyme',
    name: '스탠바이미 32인치',
    category: '디스플레이',
    description: '400 × 1,200 × 350 mm',
    dimensions: { width: 0.4, height: 1.2, depth: 0.35 },
    defaultColor: '#1a1d1c',
  },
  {
    kind: 'beam-screen',
    name: '유압식 빔스크린',
    category: '디스플레이',
    description: '1,800 × 2,000 × 500 mm',
    dimensions: { width: 1.8, height: 2, depth: 0.5 },
    defaultColor: '#2c312f',
  },
  {
    kind: 'giant-banner',
    name: '자이언트 배너',
    category: '디스플레이',
    description: '900 × 2,700 × 500 mm',
    dimensions: { width: 0.9, height: 2.7, depth: 0.5 },
    defaultColor: '#f1eee6',
  },
  {
    kind: 'water-banner',
    name: '물통배너',
    category: '디스플레이',
    description: '800 × 2,200 × 600 mm',
    dimensions: { width: 0.8, height: 2.2, depth: 0.6 },
    defaultColor: '#f3f1e9',
  },
  {
    kind: 'hanger',
    name: '철제 행거',
    category: '가구',
    description: '1,200 × 1,600 × 500 mm',
    dimensions: { width: 1.2, height: 1.6, depth: 0.5 },
    defaultColor: '#dfe3df',
  },
  {
    kind: 'hanger-double',
    name: '2단 대형 행거',
    category: '가구',
    description: '1,500 × 1,600 × 550 mm',
    dimensions: { width: 1.5, height: 1.6, depth: 0.55 },
    defaultColor: '#e8ebe7',
  },
  {
    kind: 'sofa-1',
    name: '1인 쇼파',
    category: '가구',
    description: '800 × 750 × 750 mm',
    dimensions: { width: 0.8, height: 0.75, depth: 0.75 },
    defaultColor: '#4f5c56',
  },
  {
    kind: 'sofa-3',
    name: '3인 쇼파',
    category: '가구',
    description: '1,800 × 750 × 800 mm',
    dimensions: { width: 1.8, height: 0.75, depth: 0.8 },
    defaultColor: '#45524c',
  },
  {
    kind: 'fitting-room',
    name: '커튼 피팅룸',
    category: '가구',
    description: '1,000 × 2,000 × 1,000 mm',
    dimensions: { width: 1, height: 2, depth: 1 },
    defaultColor: '#1f2322',
  },
  {
    kind: 'lighting-backwall',
    name: '라이팅 백월',
    category: '부스 구조',
    description: '2,400 × 2,500 × 300 mm',
    dimensions: { width: 2.4, height: 2.5, depth: 0.3 },
    defaultColor: '#eceae2',
  },
  {
    kind: 'pipe-drape',
    name: '파이프앤드레이프',
    category: '부스 구조',
    description: '2,000 × 2,400 × 400 mm',
    dimensions: { width: 2, height: 2.4, depth: 0.4 },
    defaultColor: '#f2f0e8',
  },
  {
    kind: 'barricade',
    name: '철제 바리케이드',
    category: '장식',
    description: '2,000 × 1,100 × 150 mm',
    dimensions: { width: 2, height: 1.1, depth: 0.15 },
    defaultColor: '#6d7571',
  },
  {
    kind: 'acrylic-desk',
    name: '아크릴 안내대',
    category: '가구',
    description: '1,000 × 1,000 × 500 mm',
    dimensions: { width: 1, height: 1, depth: 0.5 },
    defaultColor: '#dfe8e6',
  },
  {
    kind: 'mini-truss',
    name: '미니 트러스 포토존',
    category: '부스 구조',
    description: '2,000 × 2,200 × 500 mm',
    dimensions: { width: 2, height: 2.2, depth: 0.5 },
    defaultColor: '#59635f',
  },
  {
    kind: 'catalog-stand-round',
    name: '라운드 카탈로그 거치대',
    category: '장식',
    description: '400 × 1,200 × 400 mm',
    dimensions: { width: 0.4, height: 1.2, depth: 0.4 },
    defaultColor: '#2f3532',
  },
  {
    kind: 'pop-stand-a3',
    name: 'A3 스탠드 POP',
    category: '디스플레이',
    description: '350 × 1,300 × 350 mm',
    dimensions: { width: 0.35, height: 1.3, depth: 0.35 },
    defaultColor: '#cfd5d1',
  },
  {
    kind: 'pop-stand-clamp',
    name: '집게형 POP 스탠드',
    category: '디스플레이',
    description: '300 × 1,200 × 300 mm',
    dimensions: { width: 0.3, height: 1.2, depth: 0.3 },
    defaultColor: '#b8bfba',
  },
  {
    kind: 'led-wood-wall',
    name: 'LED 우드월',
    category: '부스 구조',
    description: '3,000 × 2,500 × 250 mm',
    dimensions: { width: 3, height: 2.5, depth: 0.25 },
    defaultColor: '#c4a574',
  },
  {
    kind: 'block-wall',
    name: '블럭 백월',
    category: '부스 구조',
    description: '3,000 × 2,500 × 400 mm',
    dimensions: { width: 3, height: 2.5, depth: 0.4 },
    defaultColor: '#e7e6df',
  },
  {
    kind: 'block-gate',
    name: '블럭 게이트',
    category: '부스 구조',
    description: '3,000 × 2,700 × 500 mm',
    dimensions: { width: 3, height: 2.7, depth: 0.5 },
    defaultColor: '#394842',
  },
  {
    kind: 'portable-stage',
    name: '이동식 간이무대',
    category: '부스 구조',
    description: '1,800 × 400 × 1,200 mm',
    dimensions: { width: 1.8, height: 0.4, depth: 1.2 },
    defaultColor: '#5c6460',
  },
  {
    kind: 'recycling-bin',
    name: '분리수거함',
    category: '장식',
    description: '900 × 900 × 450 mm',
    dimensions: { width: 0.9, height: 0.9, depth: 0.45 },
    defaultColor: '#69716d',
  },
  {
    kind: 'mesh-rack',
    name: '회전 메쉬망 거치대',
    category: '장식',
    description: '600 × 1,600 × 600 mm',
    dimensions: { width: 0.6, height: 1.6, depth: 0.6 },
    defaultColor: '#8a9290',
  },
  {
    kind: 'jewelry-case',
    name: '주얼리 진열장',
    category: '가구',
    description: '1,000 × 1,000 × 500 mm',
    dimensions: { width: 1, height: 1, depth: 0.5 },
    defaultColor: '#f2f0e8',
  },
  {
    kind: 'giant-pole',
    name: '자이언트 폴',
    category: '디스플레이',
    description: '900 × 2,700 × 400 mm',
    dimensions: { width: 0.9, height: 2.7, depth: 0.4 },
    defaultColor: '#f4f2ea',
  },
  {
    kind: 'whiteboard',
    name: '화이트보드',
    category: '디스플레이',
    description: '1,800 × 1,200 × 500 mm',
    dimensions: { width: 1.8, height: 1.2, depth: 0.5 },
    defaultColor: '#f7f7f2',
  },
  {
    kind: 'lottery-box',
    name: '추첨함',
    category: '장식',
    description: '400 × 500 × 400 mm',
    dimensions: { width: 0.4, height: 0.5, depth: 0.4 },
    defaultColor: '#c9c5ba',
  },
  {
    kind: 'name-stand',
    name: '아크릴 네임스탠드',
    category: '장식',
    description: '250 × 200 × 80 mm',
    dimensions: { width: 0.25, height: 0.2, depth: 0.08 },
    defaultColor: '#dfe8e6',
  },
  {
    kind: 'floor-mirror',
    name: '전신 거울',
    category: '장식',
    description: '500 × 1,700 × 400 mm',
    dimensions: { width: 0.5, height: 1.7, depth: 0.4 },
    defaultColor: '#c5cbc7',
  },
  {
    kind: 'beam-projector',
    name: '빔프로젝터',
    category: '디스플레이',
    description: '450 × 1,200 × 450 mm',
    dimensions: { width: 0.45, height: 1.2, depth: 0.45 },
    defaultColor: '#2a2e2c',
  },
  {
    kind: 'fabric-frame',
    name: '텐션패브릭 프레임',
    category: '부스 구조',
    description: '2,000 × 2,300 × 300 mm',
    dimensions: { width: 2, height: 2.3, depth: 0.3 },
    defaultColor: '#f1eee6',
  },
  {
    kind: 'system-shelf',
    name: '시스템 선반',
    category: '가구',
    description: '1,000 × 2,000 × 350 mm',
    dimensions: { width: 1, height: 2, depth: 0.35 },
    defaultColor: '#e7e6df',
  },
  {
    kind: 'hanging-banner',
    name: '스탠드 행잉 배너',
    category: '디스플레이',
    description: '1,200 × 2,500 × 400 mm · 바닥 스탠드형',
    dimensions: { width: 1.2, height: 2.5, depth: 0.4 },
    defaultColor: '#f4f2ea',
  },
  {
    kind: 'led-sign',
    name: 'LED 사인보드',
    category: '디스플레이',
    description: '1,200 × 400 × 150 mm',
    dimensions: { width: 1.2, height: 0.4, depth: 0.15 },
    defaultColor: '#1a1d1c',
  },
  {
    kind: 'desktop-brochure',
    name: '탁상 카탈로그 꽂이',
    category: '장식',
    description: '250 × 300 × 200 mm',
    dimensions: { width: 0.25, height: 0.3, depth: 0.2 },
    defaultColor: '#cfd5d1',
  },
  {
    kind: 'a-board-wide',
    name: '가로형 A보드',
    category: '디스플레이',
    description: '900 × 700 × 500 mm',
    dimensions: { width: 0.9, height: 0.7, depth: 0.5 },
    defaultColor: '#2a2e2c',
  },
  {
    kind: 'round-sign',
    name: '라운드 입간판',
    category: '디스플레이',
    description: '600 × 1,500 × 400 mm',
    dimensions: { width: 0.6, height: 1.5, depth: 0.4 },
    defaultColor: '#f4f2ea',
  },
  {
    kind: 'pop-stand-a4',
    name: 'A4 스탠드 POP',
    category: '디스플레이',
    description: '220 × 1,200 × 220 mm',
    dimensions: { width: 0.22, height: 1.2, depth: 0.22 },
    defaultColor: '#c5cbc7',
  },
  {
    kind: 'lighting-gate',
    name: '라이팅 게이트',
    category: '부스 구조',
    description: '3,000 × 2,500 × 600 mm',
    dimensions: { width: 3, height: 2.5, depth: 0.6 },
    defaultColor: '#ebe7dc',
  },
  {
    kind: 'bar-table-square',
    name: '사각 바테이블',
    category: '가구',
    description: '700 × 1,100 × 700 mm',
    dimensions: { width: 0.7, height: 1.1, depth: 0.7 },
    defaultColor: '#e7e4db',
  },
  {
    kind: 'half-table',
    name: '반탁 테이블',
    category: '가구',
    description: '1,200 × 750 × 600 mm',
    dimensions: { width: 1.2, height: 0.75, depth: 0.6 },
    defaultColor: '#ebe7dc',
  },
  {
    kind: 'folding-chair',
    name: '접의자',
    category: '가구',
    description: '450 × 850 × 500 mm',
    dimensions: { width: 0.45, height: 0.85, depth: 0.5 },
    defaultColor: '#cfd5d1',
  },
  {
    kind: 'vip-chair',
    name: 'VIP 의자',
    category: '가구',
    description: '600 × 950 × 600 mm',
    dimensions: { width: 0.6, height: 0.95, depth: 0.6 },
    defaultColor: '#2f3532',
  },
  {
    kind: 'tier-display',
    name: '3단 진열대',
    category: '가구',
    description: '900 × 1,200 × 450 mm',
    dimensions: { width: 0.9, height: 1.2, depth: 0.45 },
    defaultColor: '#e7e6df',
  },
  {
    kind: 'lectern-dual',
    name: '2인 아크릴 강연대',
    category: '가구',
    description: '1,200 × 1,100 × 450 mm',
    dimensions: { width: 1.2, height: 1.1, depth: 0.45 },
    defaultColor: '#dfe8e6',
  },
  {
    kind: 'score-stand',
    name: '보면대',
    category: '장식',
    description: '450 × 1,200 × 400 mm',
    dimensions: { width: 0.45, height: 1.2, depth: 0.4 },
    defaultColor: '#2a2e2c',
  },
  {
    kind: 'led-mirror',
    name: 'LED 조명거울',
    category: '장식',
    description: '500 × 1,800 × 80 mm',
    dimensions: { width: 0.5, height: 1.8, depth: 0.08 },
    defaultColor: '#c5d0d4',
  },
  {
    kind: 'square-bin',
    name: '사각 휴지통',
    category: '장식',
    description: '350 × 700 × 350 mm',
    dimensions: { width: 0.35, height: 0.7, depth: 0.35 },
    defaultColor: '#4d5552',
  },
  {
    kind: 'steel-bin',
    name: '스테인리스 휴지통',
    category: '장식',
    description: '300 × 650 × 300 mm',
    dimensions: { width: 0.3, height: 0.65, depth: 0.3 },
    defaultColor: '#b8c0bc',
  },
];

export const TEMPLATES = [
  { id: 'expo', name: '전시 부스', size: '6 × 4 m', room: { width: 6, depth: 4, height: 2.8, wallNorth: true, wallWest: true, floorColor: '#d9d7cf' } },
  { id: 'showroom', name: '미니 쇼룸', size: '8 × 6 m', room: { width: 8, depth: 6, height: 3.2, wallNorth: true, wallWest: true, floorColor: '#c9cbc6' } },
  { id: 'open', name: '오픈 플로어', size: '10 × 8 m', room: { width: 10, depth: 8, height: 3, wallNorth: false, wallWest: false, floorColor: '#d5d2ca' } },
] as const;
